import React from "react"
import logo from "../../public/assets/images/ontario_logo.svg"
import { ProgramContainer } from "src/entities/formTemplateDataType";
import '../../public/assets/css/App.css';
import SocialMediaComponent from "./SocialMediaComponent";
import UserComponent from "../security/UserComponent";
import { MsalProvider } from "@azure/msal-react";
import msalInstance from "../security/msalInstance";

interface Props {
  programContainer: ProgramContainer;
  isEng: boolean;
  callback;
}

interface State {
  isEng: boolean;
}

export class ApplicationHeaderComponent extends React.Component<Props, State> {
 
  constructor(props: Props) {
    super(props);

    this.state = {
      isEng: this.props.isEng,
    }
    
  }

  generateHeaderString = () => {
    return (

      <div className='documentation-only--application'>
        <div className='ontario-header__container'>
          <header className='ontario-application-header ontario-header' id='ontario-header'>
            <div className='ontario-row'>
              <div className='ontario-columns ontario-small-6 ontario-application-header__logo'>
                <a href='https://www.ontario.ca/page/government-ontario'>
                  <img id="asap-logo" src={logo} alt="Government of Ontario" />
                </a>
              </div>
              <div style={{ display: this.props.programContainer.EnglishOnly ? "none" : "block" }} className='ontario-columns ontario-small-6 ontario-application-header__lang-toggle'>
                <button lang={this.state.isEng? 'fr' : 'en'} className='ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline'
                  onClick={() => this.setState({ isEng: !this.state.isEng }, () => this.props.callback(!this.props.isEng))}>
                  {this.state.isEng ? 'Français' : 'English'}
                </button>
              </div>
            </div>
          </header>
          <div className='ontario-application-subheader-menu__container'>
            <section className='ontario-application-subheader'>
              <div className='ontario-row'>
                <div className='ontario-columns ontario-small-12 ontario-application-subheader__container'>
                <p className='ontario-service-subheader__description' style={{whiteSpace: 'pre-wrap'}}>
                  {this.props.isEng ? this.props.programContainer.Name : this.props.programContainer.NameFRA}
                </p>
                  <div style={{ display: this.props.programContainer.SocialMedia == "Y" ? "block" : "none" }} >
                  <SocialMediaComponent isEng={this.props.isEng} GATrackingID={this.props.programContainer.GATrackingID}></SocialMediaComponent>
                </div>
                  {this.props.programContainer.AuthRequired == "ad" && <p className='ontario-application-subheader__heading'>
                      <a className="not-clickable"><UserComponent callback={() => this.props.callback()} /></a>
                   </p>}
                </div>
              </div>
            </section>
          </div>
        </div>
        <div className='ontario-overlay'></div>
      </div>)

  }
  render() {
    return (
      <div style={{ marginBottom: '50px' }}>
        {this.generateHeaderString()}
      </div>

    )
  }
}
